export const ReportSlideKeys = [
	'report-title',
	'report-contents',
	'profitability-section',
	'quad-section',
	'quad-period-comparison-overview',
	'customer-product-section',
	'quartile-section',
	'quad-4-section',
	'quad-1-section',
	'recommendations-section',
	'appendix-section',
	'appendix-quad-table',
	'appendix-quad-summary',
	'appendix-quartile-table',
	'appendix-quartile-summary',
	'report-executive-summary',
	'period-comparison-overview',
	'profitability-curve-actual',
	'profitability-curve-phase-1',
	'profitability-curve-phase-2',
	'profitability-curve-model',
	'profitability-curve-overhead',
	'quad-overview',
	'quad-revenue-distribution',
	'quad-margin',
	'quad-period-comparison-1-2',
	'quad-period-comparison-3-4',
	'customer-distribution',
	'product-distribution',
	'quartile-customer-product-revenue',
	'quartile-customer-breakdown',
	'quad-4-customer-observations',
	'quad-4-product-observations',
	'quad-4-breakeven',
	'quad-1-top-customers',
	'quad-1-top-products',
	'recommendations-overview',
	'qbr-section',
] as const;

export type ReportSlideKey = (typeof ReportSlideKeys)[number];

export type ReportSlideContent = string;

export type ReportSlide = {
	/**
	 * the key that dictates the template of the slide to view
	 */
	key: ReportSlideKey;

	/**
	 * Determines if the user has disabled or enabled the slide to be shown
	 * in the report. Disabled slides will NOT be shown in the "view report", but
	 * will be shown during editing.
	 */
	enabled: boolean;

	/**
	 * The user drive content to show alongside the predetermined slide templates
	 */
	content: ReportSlideContent[];

	/**
	 * Editable slide title. Seeded from the slide key. Reports created before
	 * this field omit it until the heading backfill writes it.
	 */
	header?: string;

	/**
	 * Editable slide subtitle. Empty when the slide has no subheader.
	 */
	subheader?: string;

	/**
	 * Whether this slide shows an editable subheader.
	 * Omitted values keep the key's built-in configuration. Created slides
	 * set this explicitly, and it defaults to false unless a slide opts in.
	 */
	showSubheader?: boolean;
};
